// @ts-strict-ignore
import { Box } from "@saleor/macaw-ui-next";
import React from "react";

// import AddOnsCard from "./components/AddOnsCard";
import AddOnsShowcase from "./components/AddOnsShowcase";
import BillingDetailsCard from "./components/BillingDetailsCard";
import CurrentPlanCard from "./components/CurrentPlanCard";
import InvoiceHistoryCard from "./components/InvoiceHistoryCard";

const PlanBillingSection: React.FC = () => {
  return (
    <Box paddingX={8} paddingY={6}>
      <Box as="h1" fontSize={9} fontWeight="bold" marginBottom={4}>
        Billing
      </Box>

      {/* Current plan + invoice history */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 16,
          marginBottom: 16,
        }}
      >
        <CurrentPlanCard />
        <InvoiceHistoryCard />
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 16,
          marginBottom: 16,
        }}
      >
        {/* <AddOnsCard /> */}
        <BillingDetailsCard />
      </div>

      {/* Add-ons showcase row */}
      <div style={{ marginBottom: 16 }}>
        <AddOnsShowcase />
      </div>

      {/* Bottom banner */}
      {/* <PaymentMethodBanner /> */}
    </Box>
  );
};

export default PlanBillingSection;
